<template>
  <div style="display: flex;align-items: center">
    <div>{{hint}}</div>
    <a-range-picker
      style="width: 280px;margin-left: 8px"
      @change="dateChange"
      v-model="date"
    ></a-range-picker>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    props:["hint"],
    data(){
      return {
        date:[]
      }
    },
    methods:{
      dateChange(dates,dateStrings){
        let timeFrom = parseInt(moment(dateStrings[0], "YYYY-MM-DD").format('X'))
        let timeTo = parseInt(moment(dateStrings[1], "YYYY-MM-DD").format('X')) + 24*60*60
        this.$emit("change",timeFrom,timeTo)
      },
      clear(){
        this.date=[]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datetime/RangeDatePicker.vue